if (!customElements.get('hpg-mobile-announcement')) {
  customElements.define(
    'hpg-mobile-announcement',
    class MobileAnnouncement extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-mobile-announcement-track]');
        this.group = this.querySelector('[data-mobile-announcement-group]');
        this.items = [...this.group?.querySelectorAll('[data-mobile-announcement]') || []];
        if (!this.track || !this.group || !this.items.length) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileViewport = window.matchMedia('(max-width: 749px)');
        this.refresh = this.refresh.bind(this);
        this.scheduleRefresh = this.scheduleRefresh.bind(this);
        this.reducedMotion.addEventListener('change', this.refresh);
        this.mobileViewport.addEventListener('change', this.refresh);
        this.resizeObserver = new ResizeObserver(this.scheduleRefresh);
        this.resizeObserver.observe(this);
        this.refresh();
      }

      disconnectedCallback() {
        this.reducedMotion?.removeEventListener('change', this.refresh);
        this.mobileViewport?.removeEventListener('change', this.refresh);
        this.resizeObserver?.disconnect();
        window.cancelAnimationFrame(this.refreshFrame);
      }

      scheduleRefresh() {
        window.cancelAnimationFrame(this.refreshFrame);
        this.refreshFrame = window.requestAnimationFrame(this.refresh);
      }

      refresh() {
        this.track.classList.remove('is-running', 'is-static');
        this.track.style.removeProperty('--hpg-announcement-distance');
        this.track.style.removeProperty('--hpg-announcement-duration');
        this.track.querySelector('[data-mobile-announcement-clone]')?.remove();

        if (!this.mobileViewport.matches || this.reducedMotion.matches || this.items.length === 1) {
          this.track.classList.add('is-static');
          return;
        }

        const clone = this.group.cloneNode(true);
        clone.setAttribute('data-mobile-announcement-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        this.track.appendChild(clone);

        const distance = this.group.getBoundingClientRect().width;
        if (!distance) return;

        this.track.style.setProperty('--hpg-announcement-distance', `${distance}px`);
        this.track.style.setProperty('--hpg-announcement-duration', `${Math.max(8, distance / 50)}s`);
        this.track.classList.add('is-running');
      }
    }
  );
}
